// import React, { useState } from 'react';
// import "./../../assets/css/TravelGallary.css";

// const TravelGallery = () => {
//   const [selectedCategory, setSelectedCategory] = useState('all');
//   const [selectedImage, setSelectedImage] = useState(null);
//   const [visibleCount, setVisibleCount] = useState(9);  // Show only 10 initially

//   const galleryImages = [
//     {
//       id: 1,
//       src: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800&h=600&fit=crop',
//       title: 'Mountain Adventure',
//       category: 'mountains',
//       location: 'Swiss Alps'
//     },
//     {
//       id: 2,
//       src: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=800&h=600&fit=crop',
//       title: 'Tropical Paradise',
//       category: 'beaches',
//       location: 'Maldives'
//     },
//     {
//       id: 3,
//       src: 'https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?w=800&h=600&fit=crop',
//       title: 'City Lights',
//       category: 'cities',
//       location: 'London'
//     },
//     {
//       id: 4,
//       src: 'https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=800&h=600&fit=crop',
//       title: 'Forest Trail',
//       category: 'nature',
//       location: 'Pacific Northwest'
//     },
//     {
//       id: 5,
//       src: 'https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?w=800&h=600&fit=crop',
//       title: 'Sunset Beach',
//       category: 'beaches',
//       location: 'Santorini'
//     },
//     {
//       id: 6,
//       src: 'https://images.unsplash.com/photo-1464822759844-d150ad6d1dff?w=800&h=600&fit=crop',
//       title: 'Alpine Lake',
//       category: 'mountains',
//       location: 'Canadian Rockies'
//     },
//     {
//       id: 7,
//       src: 'https://images.unsplash.com/photo-1480714378408-67cf0d13bc1f?w=800&h=600&fit=crop',
//       title: 'Urban Skyline',
//       category: 'cities',
//       location: 'New York'
//     },
//     {
//       id: 8,
//       src: 'https://images.unsplash.com/photo-1441716844725-09cedc13a4e7?w=800&h=600&fit=crop',
//       title: 'Waterfall Wonder',
//       category: 'nature',
//       location: 'Iceland'
//     },
//     {
//       id: 9,
//       src: 'https://images.unsplash.com/photo-1539650116574-75c0c6d73f6e?w=800&h=600&fit=crop',
//       title: 'Desert Dunes',
//       category: 'nature',
//       location: 'Sahara Desert'
//     },
//     {
//       id: 10,
//       src: 'https://images.unsplash.com/photo-1519985176271-adb1088fa94c?w=800&h=600&fit=crop',
//       title: 'Lakeside Cabin',
//       category: 'mountains',
//       location: 'Norway'
//     },
//     {
//       id: 11,
//       src: 'https://images.unsplash.com/photo-1506744038136-46273834b3fb?w=800&h=600&fit=crop',
//       title: 'City Park',
//       category: 'cities',
//       location: 'Paris'
//     }
//   ];

//   const getCategories = () => {
//     const uniqueCategories = [...new Set(galleryImages.map(img => img.category))];
//     const categoryList = [{ id: 'all', name: 'All Tours' }];
//     uniqueCategories.forEach(category => {
//       if (category) {
//         categoryList.push({
//           id: category,
//           name: category.charAt(0).toUpperCase() + category.slice(1)
//         });
//       }
//     });
//     return categoryList;
//   };

//   const categoryIcons = {
//     all: 'fas fa-globe',
//     beaches: 'fas fa-umbrella-beach',
//     mountains: 'fas fa-mountain',
//     cities: 'fas fa-city',
//     nature: 'fas fa-tree',
//   };

//   const categories = getCategories();
//   const filteredImages = selectedCategory === 'all'
//     ? galleryImages
//     : galleryImages.filter(img => img.category === selectedCategory);

//   const openModal = (image) => setSelectedImage(image);
//   const closeModal = () => setSelectedImage(null);

//   return (
//     <div className="container-fluid py-5" style={{ backgroundColor: '#f4f7fa', fontFamily: 'Poppins, sans-serif' }}>
//       {/* Hero Header */}
//       <div className="container mb-5 p-5 rounded-4 text-white text-center" style={{ background: 'linear-gradient(135deg, #56ccf2, #2f80ed)' }}>
//         <h1 className="display-4 fw-bold">Travel Gallery</h1>
//         <p className="lead">Discover breathtaking destinations from around the world</p>
//       </div>

//       <div className="container">
//         {/* Filter Buttons */}
//         <div className="d-flex justify-content-center flex-wrap gap-3 mb-5">
//           {categories.map(category => (
//             <button
//               key={category.id}
//               className={`filter-btn d-flex align-items-center gap-2 px-4 py-2 rounded-pill fw-semibold shadow-sm ${selectedCategory === category.id ? 'active' : ''
//                 }`}
//               onClick={() => {
//                 setSelectedCategory(category.id);
//                 setVisibleCount(10); // reset visible count on category change
//               }}
//             >
//               <i className={`${categoryIcons[category.id] || 'fas fa-map'} me-1`}></i>
//               {category.name}
//             </button>
//           ))}
//         </div>

//         {/* Gallery Grid */}
//         <div className="row g-4">
//           {filteredImages.slice(0, visibleCount).map(image => (
//             <div key={image.id} className="col-lg-4 col-md-6">
//               <div className="overlay-card position-relative overflow-hidden rounded-4 shadow-sm" onClick={() => openModal(image)}>
//                 <img
//                   src={image.src}
//                   alt={image.title}
//                   className="w-100 h-100 object-cover"
//                   style={{ height: '280px', objectFit: 'cover', cursor: 'pointer' }}
//                 />
//                 <div className="overlay-content position-absolute bottom-0 start-0 w-100 text-white p-3">
//                   <span className="badge bg-gradient px-3 py-1 mb-2">{image.category}</span>
//                   <h5 className="mb-1">{image.title}</h5>
//                   <p className="mb-2">
//                     <i className="fas fa-map-marker-alt me-1"></i>{image.location}
//                   </p>
//                   <button className="btn btn-sm btn-light">View Details</button>
//                 </div>
//                 <div className="overlay-gradient position-absolute top-0 start-0 w-100 h-100"></div>
//               </div>
//             </div>
//           ))}
//         </div>

//         {/* See More Button */}
//         {visibleCount < filteredImages.length && (
//           <div className="text-center mt-4">
//             <button
//               className="btn btn-primary px-4 py-2"
//               onClick={() => setVisibleCount(filteredImages.length)}
//             >
//               See More
//             </button>
//           </div>
//         )}

//         {/* Stats Section */}
//         <div className="stats-section py-5">
//           <div className="container">
//             <div className="row text-center mt-5 pt-5">
//               {[
//                 { icon: 'fas fa-globe-americas', value: '50+', label: 'Countries' },
//                 { icon: 'fas fa-camera', value: '1000+', label: 'Photos' },
//                 { icon: 'fas fa-users', value: '10K+', label: 'Happy Travelers' },
//                 { icon: 'fas fa-star', value: '4.9', label: 'Rating' }
//               ].map((stat, index) => (
//                 <div className="col-lg-3 col-md-6 mb-4" key={index}>
//                   <div className="stat-card text-center p-4 h-100 shadow-sm rounded-4">
//                     <div className="stat-icon mb-3">
//                       <i className={`${stat.icon} fs-1`}></i>
//                     </div>
//                     <h3 className="fw-bold mb-1">{stat.value}</h3>
//                     <p className="mb-0">{stat.label}</p>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Image Modal */}
//       {selectedImage && (
//         <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.8)' }} onClick={closeModal}>
//           <div className="modal-dialog modal-lg modal-dialog-centered" onClick={e => e.stopPropagation()}>
//             <div className="modal-content glass-modal">
//               <div className="modal-header border-0 text-white">
//                 <h5 className="modal-title">{selectedImage.title}</h5>
//                 <button type="button" className="btn-close btn-close-white" onClick={closeModal}></button>
//               </div>
//               <div className="modal-body p-0">
//                 <img src={selectedImage.src} alt={selectedImage.title} className="img-fluid w-100" style={{ maxHeight: '500px', objectFit: 'cover' }} />
//               </div>
//               <div className="modal-footer border-0 text-white d-flex justify-content-between">
//                 <div>
//                   <h6>{selectedImage.title}</h6>
//                   <p className="text-white-50 mb-0"><i className="fas fa-map-marker-alt me-2"></i>{selectedImage.location}</p>
//                 </div>
//                 <div>
//                   <button className="btn btn-outline-light me-2"><i className="fas fa-heart me-2"></i>Save</button>
//                   <button className="btn btn-outline-light"><i className="fas fa-share me-2"></i>Share</button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* External Resources */}
//       <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css" rel="stylesheet" />
//       <link href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css" rel="stylesheet" />
//       <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@400;600&display=swap" rel="stylesheet" />

//       {/* Styles */}
//       <style jsx>{`
//         .gallery-img {
//           height: 250px;
//           object-fit: cover;
//           transition: transform 0.5s ease;
//         }

//         .card:hover .gallery-img {
//           transform: scale(1.05);
//         }

//         .hover-overlay {
//           background: rgba(0, 0, 0, 0.5);
//           transition: opacity 0.3s;
//         }

//         .card:hover .hover-overlay {
//           opacity: 1 !important;
//         }

//         .stat-card {
//           background: rgba(255, 255, 255, 0.1);
//           backdrop-filter: blur(10px);
//           border-radius: 15px;
//         }

//         .glass-modal {
//           background: rgba(255, 255, 255, 0.1);
//           backdrop-filter: blur(20px);
//           border-radius: 20px;
//           color: white;
//           border: 1px solid rgba(255, 255, 255, 0.3);
//         }

//         .btn {
//           transition: all 0.3s ease;
//         }

//         .btn:hover {
//           transform: translateY(-2px);
//         }

//         .overlay-card {
//           cursor: pointer;
//           position: relative;
//           border-radius: 1rem;
//           overflow: hidden;
//         }

//         .overlay-content {
//           z-index: 10;
//         }

//         .overlay-gradient {
//           background: linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.6) 100%);
//           opacity: 1;
//           transition: opacity 0.3s ease;
//           z-index: 5;
//         }

//         .overlay-card:hover .overlay-gradient {
//           opacity: 0.8;
//         }
//       `}</style>
//     </div>
//   );
// };

// export default TravelGallery;


import React, { useEffect, useState } from "react";
import axios from "axios";
import BASE_URL from "../../component/commanfile";

const TravelGallery = () => {
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [selectedImage, setSelectedImage] = useState(null);
  const [visibleCount, setVisibleCount] = useState(9);
  const [gallaryData, setGallaryData] = useState([]);

  useEffect(() => {
    const fetchGalleryData = async () => {
      try {
        const response = await axios.get(`${BASE_URL}api/web-gallary`);
        setGallaryData(response?.data || []);
      } catch (error) {
        console.error("Error fetching gallery data:", error);
      }
    };
    fetchGalleryData();
  }, []);

  const uniqueCategories = ["all", ...new Set(gallaryData?.map((img) => img.category))];
  const filteredImages = selectedCategory === "all" 
    ? gallaryData 
    : gallaryData.filter((img) => img.category === selectedCategory);

  const visibleImages = filteredImages?.slice(0, visibleCount);

  return (
    <div className="gallery-page bg-light">
      {/* --- CURVED HERO SECTION --- */}
      <div className="hero-wrapper position-relative overflow-hidden">
        <div className="hero-section text-center d-flex align-items-center justify-content-center" 
             style={{ 
               background: "linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url('https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?q=80&w=2000') center/cover no-repeat",
               height: '450px',
               borderBottomLeftRadius: '100px', // Bottom se radius kam kiya
               borderBottomRightRadius: '100px' // Bottom se radius kam kiya
             }}>
          <div className="text-white">
            <h1 className="display-4 fw-bold">Our Travel Moments</h1>
            <p className="lead opacity-75">Every picture tells a story of an adventure.</p>
          </div>
        </div>
      </div>

      <div className="container py-5 mt-n5 position-relative z-2">
        {/* Filters Section */}
        <div className="text-center mb-5">
          <div className="d-inline-flex p-2 bg-white rounded-pill shadow">
            {uniqueCategories.map((cat) => (
              <button 
                key={cat}
                className={`btn rounded-pill px-4 py-2 border-0 fw-semibold transition-all ${selectedCategory === cat ? 'btn-primary text-white shadow' : 'btn-light text-secondary'}`}
                onClick={() => { setSelectedCategory(cat); setVisibleCount(9); }}
              >
                {cat.charAt(0).toUpperCase() + cat.slice(1)}
              </button>
            ))}
          </div>
        </div>

        {/* Blog Style Grid */}
        <div className="row g-4">
          {visibleImages.map((image) => (
            <div key={image.gallery_item_id} className="col-lg-4 col-md-6">
              <div className="card h-100 border-0 shadow-sm rounded-4 overflow-hidden blog-hover" 
                   onClick={() => setSelectedImage(image)} 
                   style={{ cursor: 'pointer' }}>
                <div style={{ height: '260px', overflow: 'hidden' }}>
                  <img
                    src={`${BASE_URL}${ (image.image?.substring(1))}`}
                    alt={image.title}
                    className="w-100 h-100 object-fit-cover transition-img"
                   
                  />
                </div>
                <div className="card-body p-4 bg-white">
                  <span className="badge bg-primary-subtle text-primary mb-2 rounded-pill px-3 py-2">{image.category}</span>
                  <h5 className="fw-bold text-dark mt-2 mb-1">{image.title}</h5>
                  <p className="text-muted small mb-0">
                    <i className="fas fa-map-marker-alt me-2 text-primary"></i>{image.location}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Load More Button */}
        {visibleCount < filteredImages.length && (
          <div className="text-center mt-5">
            <button className="btn btn-dark btn-lg rounded-pill px-5 shadow-sm" onClick={() => setVisibleCount(v => v + 6)}>
              See More Memories
            </button>
          </div>
        )}
      </div>

      {/* --- POP-UP FIXED --- */}
      {selectedImage && (
        <div className="modal show d-block p-4" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.9)', backdropFilter: 'blur(8px)', zIndex: 1050 }}>
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content border-0 bg-transparent">
              <button 
                type="button" 
                className="btn-close btn-close-white position-absolute end-0 top-0 m-3 z-3 shadow-none" 
                onClick={() => setSelectedImage(null)}
              ></button>
              
              <div className="modal-body p-0">
                <img 
                  src={`${BASE_URL}${ (selectedImage.image?.substring(1))}`} 
                  className="img-fluid rounded-4 shadow-lg w-100" 
                  alt={selectedImage.title}
                  style={{ maxHeight: '75vh', objectFit: 'contain' }}
                 
                />
                <div className="bg-white p-4 rounded-4 mt-3 shadow text-center">
                  <h4 className="fw-bold text-dark mb-1">{selectedImage.title}</h4>
                  <p className="text-muted mb-0 fw-medium">
                    <i className="fas fa-map-marker-alt text-danger me-2"></i>{selectedImage.location}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* --- Extra Styles --- */}
      <style jsx>{`
        .hero-section {
          transition: border-radius 0.5s ease;
        }
        .mt-n5 { margin-top: -60px !important; }
        .transition-img { transition: transform 0.6s cubic-bezier(0.165, 0.84, 0.44, 1); }
        .blog-hover:hover .transition-img { transform: scale(1.1); }
        .blog-hover { transition: all 0.3s ease; }
        .blog-hover:hover { transform: translateY(-12px); box-shadow: 0 20px 30px rgba(0,0,0,0.1) !important; }
        .bg-primary-subtle { background-color: #e7f1ff; font-size: 0.7rem; letter-spacing: 0.5px; }
        .transition-all { transition: all 0.2s ease; }
        .object-fit-cover { object-fit: cover; }
        .z-2 { z-index: 2; }
      `}</style>
    </div>
  );
};

export default TravelGallery;